<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 14:28:41
-->
<template>
    <div class="errorPage">
        <a-result class="errorResult" status="404" title="404" :sub-title="t('base.pageNotFound')">
            <template #extra>
                <a-button type="primary" @click="goHomePage">{{ t('base.backHome') }}</a-button>
            </template>
        </a-result>
    </div>
</template>

<script setup>
    import {onMounted, onUnmounted, reactive, ref} from 'vue';
    import { useRouter } from 'vue-router';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n() 
    const router = useRouter()

    const goHomePage = ()=>{
        router.replace('/Home')
    }

    onMounted(()=>{})
    

</script>

<style lang="scss" scoped>
.errorPage{
    height: 100vh;
    overflow-y: scroll;

    .errorResult{
        margin-top: 100px;
    }
}
</style>